var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pa-5" },
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.orderStatusGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.orderStatusGetErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.customerGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.customerGetErrors = $event
          }
        }
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-autocomplete",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Customer",
                      items: _vm.customerList,
                      "item-value": "id",
                      "item-text": "company",
                      loading: _vm.customerGetting,
                      "error-messages": _vm.errorMessages.customerId || [],
                      filter: _vm.filterCustomerList,
                      outlined: "outlined",
                      dense: "dense"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function({ item }) {
                          return [
                            _c("span", { staticClass: "mr-2 primary--text" }, [
                              _vm._v(_vm._s(item.id))
                            ]),
                            _c("small", { staticClass: "grey--text" }, [
                              _vm._v(_vm._s(item.company))
                            ])
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function({ item }) {
                          return [
                            _c("span", { staticClass: "mr-2 primary--text" }, [
                              _vm._v(_vm._s(item.id))
                            ]),
                            _c("small", { staticClass: "grey--text" }, [
                              _vm._v(_vm._s(item.company))
                            ])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.customerId,
                      callback: function($$v) {
                        _vm.customerId = $$v
                      },
                      expression: "customerId"
                    }
                  },
                  "v-autocomplete",
                  _vm.fieldAttributes.customer,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "PO#",
                  outlined: "",
                  dense: "",
                  "hide-details": "auto"
                },
                model: {
                  value: _vm.poNumber,
                  callback: function($$v) {
                    _vm.poNumber = $$v
                  },
                  expression: "poNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  "hide-details": "auto",
                  label: "Project Code",
                  "item-value": "id",
                  "item-text": "description",
                  items: _vm.projectCodeIndexList,
                  loading: _vm.projectCodeIndexGetting,
                  "search-input": _vm.searchProjectCode,
                  "error-messages": _vm.errorMessages.project_code_id || [],
                  clearable: "clearable",
                  "no-filter": "no-filter",
                  outlined: "outlined",
                  dense: "dense"
                },
                on: {
                  "update:searchInput": function($event) {
                    _vm.searchProjectCode = $event
                  },
                  "update:search-input": function($event) {
                    _vm.searchProjectCode = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.project_code))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.project_code))
                        ]),
                        _c("small", { staticClass: "ml-2 blue-grey--text" }, [
                          _vm._v(_vm._s(item.description))
                        ])
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.projectCodeId,
                  callback: function($$v) {
                    _vm.projectCodeId = $$v
                  },
                  expression: "projectCodeId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-autocomplete",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Delivered By",
                      items: _vm.computedEmployeeList,
                      "item-value": "id",
                      "error-messages": _vm.errorMessages.deliveredBy || [],
                      clearable: "clearable",
                      outlined: "outlined",
                      dense: "dense",
                      filter: _vm.employeeFilter
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function({ item }) {
                          return [
                            _c("span", { staticClass: "primary--text" }, [
                              _vm._v(_vm._s(item.id))
                            ])
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function({ item }) {
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  (item.disabled ? "grey" : "primary") +
                                  "--text"
                              },
                              [_c("span", [_vm._v(_vm._s(item.id))])]
                            ),
                            _c(
                              "small",
                              { staticClass: "ml-2 text-uppercase grey--text" },
                              [_vm._v(_vm._s(_vm.getName(item)))]
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.deliveredBy,
                      callback: function($$v) {
                        _vm.deliveredBy = $$v
                      },
                      expression: "deliveredBy"
                    }
                  },
                  "v-autocomplete",
                  _vm.fieldAttributes.deliveredBy,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-autocomplete",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "CO Deliverer",
                      items: _vm.computedEmployeeList,
                      "item-value": "id",
                      "error-messages": _vm.errorMessages.coDeliverer || [],
                      clearable: "clearable",
                      outlined: "outlined",
                      dense: "dense",
                      filter: _vm.employeeFilter
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function({ item }) {
                          return [
                            _c("span", { staticClass: "primary--text" }, [
                              _vm._v(" " + _vm._s(item.id) + " ")
                            ])
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function({ item }) {
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  (item.disabled ? "grey" : "primary") +
                                  "--text"
                              },
                              [
                                _c("span", [
                                  _vm._v(" " + _vm._s(item.id) + " ")
                                ])
                              ]
                            ),
                            _c(
                              "small",
                              { staticClass: "ml-2 text-uppercase grey--text" },
                              [_vm._v(" " + _vm._s(_vm.getName(item)) + " ")]
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.coDeliverer,
                      callback: function($$v) {
                        _vm.coDeliverer = $$v
                      },
                      expression: "coDeliverer"
                    }
                  },
                  "v-autocomplete",
                  _vm.fieldAttributes.coDeliverer,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-text-field",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Order Date",
                      "error-messages": _vm.errorMessages.orderDate || [],
                      type: "date",
                      outlined: "outlined",
                      dense: "dense"
                    },
                    model: {
                      value: _vm.orderDate,
                      callback: function($$v) {
                        _vm.orderDate = $$v
                      },
                      expression: "orderDate"
                    }
                  },
                  "v-text-field",
                  _vm.fieldAttributes.orderDate,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-text-field",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Scheduled Delivery Date",
                      "error-messages": _vm.errorMessages.deliveryDate || [],
                      clearable: "clearable",
                      outlined: "outlined",
                      dense: "dense",
                      type: "date"
                    },
                    model: {
                      value: _vm.deliveryDate,
                      callback: function($$v) {
                        _vm.deliveryDate = $$v
                      },
                      expression: "deliveryDate"
                    }
                  },
                  "v-text-field",
                  _vm.fieldAttributes.scheduledDeliveryDate,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-text-field",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Actual Delivery Date",
                      type: "date",
                      "error-messages":
                        _vm.errorMessages.actualDeliveryDate || [],
                      clearable: "clearable",
                      outlined: "outlined",
                      dense: "dense"
                    },
                    model: {
                      value: _vm.actualDeliveryDate,
                      callback: function($$v) {
                        _vm.actualDeliveryDate = $$v
                      },
                      expression: "actualDeliveryDate"
                    }
                  },
                  "v-text-field",
                  _vm.fieldAttributes.actualDeliveryDate,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-text-field",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Paid Date",
                      type: "date",
                      disabled: "disabled",
                      outlined: "outlined",
                      dense: "dense",
                      "error-messages": _vm.errorMessages.paidDate || [],
                      clearable: "clearable"
                    },
                    model: {
                      value: _vm.paidDate,
                      callback: function($$v) {
                        _vm.paidDate = $$v
                      },
                      expression: "paidDate"
                    }
                  },
                  "v-text-field",
                  _vm.fieldAttributes.paidDate,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-text-field",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Address",
                      outlined: "outlined",
                      dense: "dense",
                      "error-messages": _vm.errorMessages.address || []
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function() {
                          return [
                            _vm.address === _vm.defaultFieldValues.address
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      "x-small": "",
                                      color: "blue-grey darken-1"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.address = _vm.getCustomerAddress()
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-folder")])],
                                  1
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      "x-small": "",
                                      color: "blue-grey darken-1"
                                    },
                                    on: { click: _vm.updateAddress }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-refresh")])],
                                  1
                                )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  },
                  "v-text-field",
                  _vm.fieldAttributes.address,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c("v-select", {
                attrs: {
                  "hide-details": "auto",
                  outlined: "",
                  dense: "",
                  label: "Order Type",
                  "error-messages": _vm.errorMessages.order_type || [],
                  items: ["other", "services", "materials"]
                },
                model: {
                  value: _vm.orderType,
                  callback: function($$v) {
                    _vm.orderType = $$v
                  },
                  expression: "orderType"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-text-field",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Shipping Fee",
                      type: "number",
                      outlined: "outlined",
                      dense: "dense",
                      "error-messages": _vm.errorMessages.shippingFee || [],
                      clearable: "clearable"
                    },
                    model: {
                      value: _vm.shippingFee,
                      callback: function($$v) {
                        _vm.shippingFee = $$v
                      },
                      expression: "shippingFee"
                    }
                  },
                  "v-text-field",
                  _vm.fieldAttributes.shippingFee,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-autocomplete",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Order Status",
                      items: _vm.computedOrderStatusList,
                      "item-value": "id",
                      "item-text": "name",
                      outlined: "outlined",
                      dense: "dense",
                      disabled: ["CP", "PL"].includes(_vm.orderStatusId),
                      "error-messages": _vm.errorMessages.orderStatusId || [],
                      clearable: "clearable"
                    },
                    model: {
                      value: _vm.orderStatusId,
                      callback: function($$v) {
                        _vm.orderStatusId = $$v
                      },
                      expression: "orderStatusId"
                    }
                  },
                  "v-autocomplete",
                  _vm.fieldAttributes.orderStatus,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-autocomplete",
                        _vm._b(
                          {
                            attrs: {
                              "hide-details": "auto",
                              label: "Payment Type",
                              outlined: "outlined",
                              dense: "dense",
                              "error-messages":
                                _vm.errorMessages.paymentType || [],
                              clearable: "clearable",
                              items: ["Cash", "Check"]
                            },
                            model: {
                              value: _vm.paymentType,
                              callback: function($$v) {
                                _vm.paymentType = $$v
                              },
                              expression: "paymentType"
                            }
                          },
                          "v-autocomplete",
                          _vm.fieldAttributes.paymentType,
                          false
                        )
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-autocomplete",
                _vm._b(
                  {
                    attrs: {
                      "hide-details": "auto",
                      label: "Payment Terms",
                      outlined: "outlined",
                      dense: "dense",
                      "error-messages": _vm.errorMessages.paymentTerms || [],
                      clearable: "clearable",
                      items: [0, 7, 15, 30]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function({ item }) {
                          return [
                            !item
                              ? _c("span", [_vm._v("COD")])
                              : _c("span", [_vm._v(_vm._s(item) + " days")])
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function({ item }) {
                          return [
                            !item
                              ? _c("span", [_vm._v("COD")])
                              : _c("span", [_vm._v(_vm._s(item) + " days")])
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.paymentTerms,
                      callback: function($$v) {
                        _vm.paymentTerms = $$v
                      },
                      expression: "paymentTerms"
                    }
                  },
                  "v-autocomplete",
                  _vm.fieldAttributes.paymentTerms,
                  false
                )
              )
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "checkbox-input", attrs: { cols: "3" } },
            [
              _c("v-checkbox", {
                staticClass: "mt-0",
                attrs: { label: "VAT (12%)" },
                model: {
                  value: _vm.vat,
                  callback: function($$v) {
                    _vm.vat = $$v
                  },
                  expression: "vat"
                }
              }),
              _c("v-checkbox", {
                staticClass: "mt-0 ml-2",
                attrs: { label: "Show Discount" },
                model: {
                  value: _vm.showDiscount,
                  callback: function($$v) {
                    _vm.showDiscount = $$v
                  },
                  expression: "showDiscount"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "9", cols: "12" } },
            [
              _c(
                "v-textarea",
                _vm._b(
                  {
                    attrs: {
                      outlined: "outlined",
                      "no-resize": "no-resize",
                      label: "Notes",
                      "error-messages": _vm.errorMessages.notes || [],
                      clearable: "clearable"
                    },
                    model: {
                      value: _vm.notes,
                      callback: function($$v) {
                        _vm.notes = $$v
                      },
                      expression: "notes"
                    }
                  },
                  "v-textarea",
                  _vm.fieldAttributes.notes,
                  false
                )
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }